import React from 'react';
import Breadcrumbs from '../components/Breadcrumbs';
import { FaShieldAlt, FaChild, FaUsers, FaFileAlt, FaDownload, FaExclamationTriangle, FaCheckCircle, FaPhone, FaEnvelope } from 'react-icons/fa';
import './ProteccionMenores.css';

const ProteccionMenores = () => {
  return (
    <div className="proteccion-menores-page">
      <Breadcrumbs />
      <section className="section">
        <div className="container">
          <div className="proteccion-header">
            <div className="proteccion-icon-large">
              <FaShieldAlt />
            </div>
            <h1 className="page-title">La IGLESIA un lugar seguro</h1>
            <p className="page-subtitle">
              Todos somos protectores de los menores y personas vulnerables
            </p>
          </div>

          <div className="proteccion-content">
            {/* Mensaje Principal */}
            <div className="proteccion-alert">
              <FaExclamationTriangle className="alert-icon" />
              <div className="alert-content">
                <h2>Compromiso con la Protección</h2>
                <p>
                  La Diócesis de Ipiales está comprometida con la protección integral de menores 
                  y personas vulnerables. Trabajamos activamente para crear espacios seguros donde 
                  todos puedan crecer en la fe sin riesgo de abuso.
                </p>
              </div>
            </div>

            {/* Protocolo de Cuidado */}
            <section className="proteccion-section">
              <div className="section-header">
                <FaFileAlt className="section-icon" />
                <h2>Protocolo de Cuidado y Protección</h2>
              </div>
              <div className="section-content">
                <p>
                  La Diócesis de Ipiales ha establecido un protocolo integral para la protección 
                  de menores y personas vulnerables, en cumplimiento con las directrices de la 
                  Iglesia Católica y la normativa colombiana.
                </p>
                
                <div className="protocolo-grid">
                  <div className="protocolo-item">
                    <FaCheckCircle className="protocolo-icon" />
                    <h3>Prevención</h3>
                    <p>
                      Implementamos medidas preventivas para evitar situaciones de riesgo, 
                      incluyendo formación continua y procesos de selección rigurosos.
                    </p>
                  </div>
                  <div className="protocolo-item">
                    <FaCheckCircle className="protocolo-icon" />
                    <h3>Detección</h3>
                    <p>
                      Contamos con mecanismos claros para identificar y reportar situaciones 
                      que puedan poner en riesgo a menores o personas vulnerables.
                    </p>
                  </div>
                  <div className="protocolo-item">
                    <FaCheckCircle className="protocolo-icon" />
                    <h3>Respuesta</h3>
                    <p>
                      Establecemos procedimientos claros para responder de manera inmediata 
                      y adecuada ante cualquier situación de riesgo o abuso.
                    </p>
                  </div>
                  <div className="protocolo-item">
                    <FaCheckCircle className="protocolo-icon" />
                    <h3>Acompañamiento</h3>
                    <p>
                      Brindamos acompañamiento integral a las víctimas y sus familias, 
                      garantizando su bienestar y protección.
                    </p>
                  </div>
                </div>
              </div>
            </section>

            {/* Principios Fundamentales */}
            <section className="proteccion-section">
              <div className="section-header">
                <FaUsers className="section-icon" />
                <h2>Principios Fundamentales</h2>
              </div>
              <div className="section-content">
                <div className="principios-list">
                  <div className="principio-item">
                    <h3>1. Dignidad de la Persona</h3>
                    <p>
                      Toda persona, especialmente menores y vulnerables, tiene derecho a ser 
                      tratada con dignidad y respeto, sin ningún tipo de abuso o maltrato.
                    </p>
                  </div>
                  <div className="principio-item">
                    <h3>2. Cero Tolerancia</h3>
                    <p>
                      Adoptamos una política de cero tolerancia ante cualquier forma de abuso, 
                      maltrato o negligencia hacia menores o personas vulnerables.
                    </p>
                  </div>
                  <div className="principio-item">
                    <h3>3. Transparencia</h3>
                    <p>
                      Mantenemos procesos transparentes y comunicamos claramente nuestras 
                      políticas y procedimientos de protección.
                    </p>
                  </div>
                  <div className="principio-item">
                    <h3>4. Responsabilidad</h3>
                    <p>
                      Todos los miembros de la comunidad diocesana son responsables de proteger 
                      y cuidar a los menores y personas vulnerables.
                    </p>
                  </div>
                </div>
              </div>
            </section>

            {/* Medidas de Protección */}
            <section className="proteccion-section">
              <div className="section-header">
                <FaShieldAlt className="section-icon" />
                <h2>Medidas de Protección Implementadas</h2>
              </div>
              <div className="section-content">
                <div className="medidas-grid">
                  <div className="medida-item">
                    <h3>Formación Continua</h3>
                    <ul>
                      <li>Capacitación obligatoria para todo el personal</li>
                      <li>Talleres de prevención y detección</li>
                      <li>Actualización constante de protocolos</li>
                    </ul>
                  </div>
                  <div className="medida-item">
                    <h3>Procesos de Selección</h3>
                    <ul>
                      <li>Verificación de antecedentes</li>
                      <li>Entrevistas y referencias</li>
                      <li>Evaluación psicológica cuando sea necesario</li>
                    </ul>
                  </div>
                  <div className="medida-item">
                    <h3>Supervisión y Monitoreo</h3>
                    <ul>
                      <li>Supervisión constante de actividades</li>
                      <li>Política de puertas abiertas</li>
                      <li>Registro de actividades con menores</li>
                    </ul>
                  </div>
                  <div className="medida-item">
                    <h3>Canales de Denuncia</h3>
                    <ul>
                      <li>Líneas de atención directa</li>
                      <li>Correo electrónico dedicado</li>
                      <li>Procedimientos confidenciales</li>
                    </ul>
                  </div>
                </div>
              </div>
            </section>

            {/* Documentos y Recursos */}
            <section className="proteccion-section">
              <div className="section-header">
                <FaFileAlt className="section-icon" />
                <h2>Documentos y Recursos</h2>
              </div>
              <div className="section-content">
                <div className="documentos-box">
                  <p>
                    El protocolo completo de cuidado y protección de menores está disponible 
                    en formato PDF para su consulta y descarga.
                  </p>
                  <div className="documento-download">
                    <FaFileAlt className="documento-icon" />
                    <div className="documento-info">
                      <h3>Protocolo de Cuidado y Protección de Menores</h3>
                      <p>Documento oficial de la Diócesis de Ipiales</p>
                    </div>
                    <button className="btn btn-download" disabled>
                      <FaDownload /> Descargar PDF
                    </button>
                  </div>
                  <p className="documento-nota">
                    <strong>Nota:</strong> El documento PDF estará disponible próximamente. 
                    Por favor, contacte a la Diócesis para más información.
                  </p>
                </div>
              </div>
            </section>

            {/* Contacto y Denuncias */}
            <section className="proteccion-section">
              <div className="section-header">
                <FaPhone className="section-icon icon-phone-upright" />
                <h2>¿Cómo Reportar una Situación?</h2>
              </div>
              <div className="section-content">
                <div className="contacto-box">
                  <p>
                    Si tiene conocimiento de alguna situación que pueda poner en riesgo a un menor 
                    o persona vulnerable, por favor repórtela inmediatamente:
                  </p>
                  <div className="contacto-info">
                    <div className="contacto-item">
                      <FaPhone className="contacto-icon icon-phone-upright" />
                      <div>
                        <h3>Línea de Atención</h3>
                        <p>Teléfono: [Número de teléfono]</p>
                        <p>Horario: Lunes a Viernes, 8:00 AM - 5:00 PM</p>
                      </div>
                    </div>
                    <div className="contacto-item">
                      <FaEnvelope className="contacto-icon" />
                      <div>
                        <h3>Correo Electrónico</h3>
                        <p>proteccion@diocesisdeipiales.org</p>
                        <p>Respuesta en máximo 24 horas</p>
                      </div>
                    </div>
                  </div>
                  <div className="contacto-alert">
                    <FaExclamationTriangle />
                    <p>
                      <strong>Importante:</strong> En caso de emergencia o situación de riesgo 
                      inmediato, contacte a las autoridades competentes (Policía, ICBF, Fiscalía) 
                      de manera inmediata.
                    </p>
                  </div>
                </div>
              </div>
            </section>

            {/* Compromiso */}
            <section className="proteccion-section compromiso-section">
              <div className="compromiso-box">
                <FaChild className="compromiso-icon" />
                <h2>Nuestro Compromiso</h2>
                <p>
                  La Diócesis de Ipiales reafirma su compromiso inquebrantable con la protección 
                  de menores y personas vulnerables. Trabajamos incansablemente para crear y 
                  mantener espacios seguros donde todos puedan crecer en la fe, libres de cualquier 
                  forma de abuso o maltrato.
                </p>
                <p>
                  Juntos, como comunidad de fe, somos responsables de proteger a los más pequeños 
                  y vulnerables entre nosotros. Este es nuestro deber sagrado y nuestro compromiso 
                  permanente.
                </p>
              </div>
            </section>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ProteccionMenores;
